import React from "react";
import { ParallaxProvider } from "react-scroll-parallax";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import Container from "./screens/SpaScreen";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB1ydmCMupTVPv8C0qZ-ngM9L5qCCX0QLM",
  authDomain: "wake-landing-page.firebaseapp.com",
  projectId: "wake-landing-page",
  storageBucket: "wake-landing-page.appspot.com",
  messagingSenderId: "654648608903",
  appId: "1:654648608903:web:d9a9905d2bd2c26b5b5022",
  measurementId: "G-2MKV07S1C1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const App = () => {
  return (
    <ParallaxProvider>
      <Container />
    </ParallaxProvider>
  );
};

export default App;
